export default __webpack_public_path__ + "static/media/Djeco-Baby-Popi-1.c7b46651.jpg";